import { render, staticRenderFns } from "./goods_list.vue?vue&type=template&id=7f0ae16f&scoped=true"
import script from "./goods_list.vue?vue&type=script&lang=js"
export * from "./goods_list.vue?vue&type=script&lang=js"
import style0 from "./goods_list.vue?vue&type=style&index=0&id=7f0ae16f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0ae16f",
  null
  
)

export default component.exports